// Pořadí vlaječek produktu: od nejkratšího štítku po nejdelší. Dřív ho na
// kartách i detailu skládal doplněk ostré „Chytré řazení příznaků"
// (dominikmartini/flag_sort, odinstalovaný 25. 9. 2026); bez něj šly vlaječky
// v pořadí z adminu a na každé kartě jinak. Shodná délka drží pořadí z adminu.

import SHOP from '../../config/shop.js';

// Akční vlaječky: výprodej skladu (manifest `catalog.clearanceFlag`) a akční
// nabídka (`flag-action`, „Slevoakce" — Shoptet ji zapíná sám podle akční ceny).
// Výprodejové zboží nese obě (11 z 12 karet ostré `/vyprodej/`, 6. 10.), karta
// pak říkala totéž dvakrát. Štítky se klíčují třídou, ne textem.
const CLEARANCE_FLAG = SHOP.catalog.clearanceFlag;
const ACTION_FLAG = 'flag-action';

/** Je vlaječka výprodeje skladu? */
export function isClearanceFlag(flag) {
  return !!CLEARANCE_FLAG && !!flag && flag.classList.contains(CLEARANCE_FLAG);
}

/** Je vlaječka akční nabídky („Slevoakce")? */
export function isActionFlag(flag) {
  return !!flag && flag.classList.contains(ACTION_FLAG);
}

/**
 * Jeden akční štítek (plán kampaní 6. 10.): z výprodeje skladu a akční nabídky
 * zůstane jen jedna vlaječka, výprodej má přednost. Ostatní vlaječky beze změny.
 * @param {Element[]} flags
 * @returns {Element[]}
 */
export function oneActionFlag(flags) {
  const keep = flags.find(isClearanceFlag) || flags.find(isActionFlag) || null;
  return flags.filter(function (flag) {
    return flag === keep || !(isClearanceFlag(flag) || isActionFlag(flag));
  });
}

/**
 * Seřadí položky podle délky štítku (stabilně).
 * @template T
 * @param {T[]} items
 * @param {(item: T) => string} labelOf
 * @returns {T[]}
 */
export function byLabelLength(items, labelOf) {
  return items
    .map(function (item, i) {
      return { item: item, i: i, n: String(labelOf(item) || '').trim().length };
    })
    .sort(function (a, b) {
      return a.n - b.n || a.i - b.i;
    })
    .map(function (x) {
      return x.item;
    });
}
